import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";

const Profile = () => {
  const [user, setUser] = useState(null);
  const [logo, setLogo] = useState(null); // Estado para la imagen
  const navigate = useNavigate();

  useEffect(() => {
    const loggedUserData = JSON.parse(localStorage.getItem("user"));
    console.log( loggedUserData);
    if (loggedUserData && loggedUserData.data && loggedUserData.data.user) {
      setUser(loggedUserData.data.user);
      setLogo(loggedUserData.data.user.imagen); // Inicializamos la imagen
    } else {
      navigate("/signin");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/signin");
  };

  const handleNavigateHome = () => {
    navigate("/");
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setLogo(ev.target.result); // Actualiza la vista previa
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="Profile" />
      <div className="pb-10 text-center">
        {user ? (
          <>
            <h1 className="text-4xl font-bold mb-6">
              Bienvenido, {user.nombre}!
            </h1>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-xl mx-auto text-left">
              <label className="block">
                <span className="font-semibold">Nick:</span>
                <input
                  type="text"
                  value={user.nick}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">Email:</span>
                <input
                  type="email"
                  value={user.email}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">CUIT:</span>
                <input
                  type="text"
                  value={user.cuit}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">Dirección:</span>
                <input
                  type="text"
                  value={user.direccion}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">Código Postal:</span>
                <input
                  type="text"
                  value={user.codigopostal}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">Teléfono:</span>
                <input
                  type="text"
                  value={user.telefono}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">Provincia:</span>
                <input
                  type="text"
                  value={user.provincia}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">Localidad:</span>
                <input
                  type="text"
                  value={user.localidad}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">País:</span>
                <input
                  type="text"
                  value={user.pais}
                  readOnly
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">Imagen (Logo):</span>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="border p-2 w-full"
                />
                {logo && (
                  <img
                    src={logo}
                    alt="Logo"
                    className="mt-2 w-32 h-32 object-contain border"
                  />
                )}
              </label>
            </div>

            <div className="mt-6">
              <button
                onClick={handleNavigateHome}
                className="w-40 h-10 bg-primeColor text-white text-lg hover:bg-black duration-300 mr-4"
              >
                Inicio
              </button>
              <button
                onClick={handleLogout}
                className="w-40 h-10 bg-primeColor text-white text-lg hover:bg-black duration-300"
              >
                Cerrar sesión
              </button>
            </div>
          </>
        ) : (
          <p>Cargando...</p>
        )}
      </div>
    </div>
  );
};

export default Profile;
